
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class GstReportSummaryWithGstinGrid extends Serenity.EntityGrid<GstReportSummaryWithGstinRow, any> {
        protected getColumnsKey() { return GstReportSummaryWithGstinColumns.columnsKey; }
        protected getDialogType() { return GstReportSummaryWithGstinDialog; }
        protected getIdProperty() { return GstReportSummaryWithGstinRow.idProperty; }
        protected getInsertPermission() { return GstReportSummaryWithGstinRow.insertPermission; }
        protected getLocalTextPrefix() { return GstReportSummaryWithGstinRow.localTextPrefix; }
        protected getService() { return GstReportSummaryWithGstinService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 1);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: GstReportSummaryWithGstinService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}